/**
 * @flow
 * @author Box
 */

export type AiItemBaseTypeField = 'file';

export interface AiItemBase {
    /**
     * The id of the item.
     */
    +id: string;
    /**
     * The type of the item.
     */
    +type: AiItemBaseTypeField;
    /**
     * The content of the item, often the text representation.
     */
    +content?: string;
}
